export default __webpack_public_path__ + "static/media/logo.a77c200b.png";